import { IChatFile } from '../components';
import { ChatFile } from './chat-file';

export interface IChatMessage {
  from?: string;
  message?: string;
  file?: ChatFile;
  to?: string;
  _id?: string;
  date?: Date;
}

export class ChatMessage {
  from: string;
  message: string;
  file: ChatFile;
  to: string;
  _id: string;
  date: Date;
  mine: boolean;

  constructor(data: IChatMessage) {
    this.from = data.from;
    this.message = data.message;
    this.file = data.file || null;
    this.to = data.to;
    this._id = data._id;
    this.date = data.date ? new Date(data.date) : new Date();
  }
}



// WEBPACK FOOTER //
// ./app/states/chat/models/chat-message.ts